import { DiaryReportService } from './../../services/diary-report.service';
import { Component, OnInit } from '@angular/core';
import { MasterDataService } from '../../services/master-data.service';
import { CommonMessageService } from 'src/app/services/common-message.service';
import { NgModel } from '@angular/forms';
import { BranchFilterService } from 'src/app/services/branch-filter.service';

@Component({
  selector: 'app-bank-payment-report',
  templateUrl: './bank-payment-report.component.html',
  styleUrls: ['./bank-payment-report.component.css']
})
export class BankPaymentReportComponent implements OnInit {

  financialList;
  selectedBranch;
  selectedClosing;
  selectedFinancialYear;
  branchList;
  closingDateList;
  bankPaymentList = [];
  isBranchSelected = false;
  userRole;
  accessResponse: any;

  constructor(private masterDataService: MasterDataService,
    private diaryReportService: DiaryReportService, private commonMessageService: CommonMessageService,
    private branchFilterService: BranchFilterService
  ) { }

  ngOnInit(): void {
    this.selectedBranch = "";
    this.selectedClosing = "";
    this.selectedFinancialYear = "";
    this.loadFinancialDetails();
    this.loadBranchDetails();
  }

  loadFinancialDetails() {
    this.accessResponse = JSON.parse(localStorage.getItem('accessResponse'));
    this.masterDataService.getFinancialYear().subscribe((res) => {
      this.financialList = res;
    });
  }

  loadBranchDetails() {
    // this.masterDataService.getBranch().subscribe((res:any) => {
    //   this.branchList = res;
    // });

    this.masterDataService.getBranch().subscribe((res) => {
      const branches = res as any[];
      const userBranchId = Number(localStorage.getItem('branchId'));

      this.branchList = this.branchFilterService.getFilteredBranches(branches, this.accessResponse, userBranchId);
    });
  }

  selectAllBranch(select: NgModel, values) {
    this.selectAll(select, values, this.isBranchSelected, false);
    this.showExportToExcelButton = false;
    this.isBranchSelected = !this.isBranchSelected;
  }

  selectAll(select: NgModel, values, isSelected, isId) {
    this.showExportToExcelButton = false;
    if (!isSelected) {
      select.update.emit(values);
    } else select.update.emit([]);
  }

  onFinancialYearSlected() {
    if (
      this.selectedFinancialYear != null &&
      this.selectedFinancialYear != undefined &&
      this.selectedFinancialYear != ''
    ) {
      this.masterDataService
        .getClosingDatesByFinancialYear(this.selectedFinancialYear.id)
        .subscribe((res) => {
          this.closingDateList = res;
        });
    }
  }

  // getClosingDate(){
  //   this.diaryReportService.getDiaryClosingDate().subscribe((res:any)=>{
  //     console.log('closing date',res);
  //     this.closingDateList=res;
  //   })
  // }

  showExportToExcelButton: boolean;
  branchId;
  onViewReport() {
    this.bankPaymentList = [];
    this.branchId = this.selectedBranch.map(({ id }) => id);
    console.log('branch id', this.branchId);
    this.masterDataService.getBankPaymentDetails(this.branchId, this.selectedClosing).subscribe((res: any) => {
      console.log('bank statement report', res);
      this.bankPaymentList = res;
      if (this.bankPaymentList.length > 0) {
        this.showExportToExcelButton = true;
      } else {
        this.commonMessageService.swalAlertWithoutIcon('', 'No Record Found.');
        this.showExportToExcelButton = false;
      }
    });
  }

  onExportToExcelReport() {
    this.masterDataService.getBankPaymentExportToExcel(this.branchId, this.selectedClosing).subscribe((resp: any) => {
      const blob = new Blob([resp]); // you can change the type
      var downloadURL = window.URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download = "BankPaymentReport.xlsx";
      link.click();
    });

  }
}
